import injectNewHeaderCartData from '../../methods/injectNewHeaderCartData'

function trackCartTotal(total) {
    try {
        if (typeof window !== 'undefined' && window._paq && (total || total === 0)) {
            // Pass raw value (object or number) � legacy basket.js does same
            const numericTotal = (typeof total === 'object' && total.amount) ? total.amount : total;
            if (!isNaN(parseFloat(numericTotal))) {
                window._paq.push(['trackEcommerceCartUpdate', parseFloat(numericTotal)]);
            }
        }
    } catch (e) { /* silent */ }
}

export default {
    namespaced: true,
    state: {

        checkoutCart: {},
        courseInfoForCheckout : {},
        formComplete: false,
        attemptedSubmit: false,
        acceptedConditions: false,
        acceptedNewsletter: false,
        couponNotValidMessage: "",
        couponHttpStatus: null,
    },
    mutations:{
        setAcceptedConditions(state,status){
            state.acceptedConditions = status
        },
        setAcceptedNewsletter(state,status){
            state.acceptedNewsletter = status
        },
        attemptSubmit(state){
            state.attemptedSubmit = true
        },
        setFormComplete(state,status){
            state.formComplete = status
        },
        setCourseInfoForCheckout(state,cartItems){

            const data = cartItems.filter(item => item.isCourse)

            const coursesForCheckout = data.reduce((finalObj,currentObj)=>{
                finalObj.push({
                    courseTitle: currentObj.displayName,
                    date : currentObj.courseDetails.date,
                    location: currentObj.courseDetails.location,
                    duration: currentObj.courseDetails.duration,
                    participantCount: currentObj.participants.length,
                    code: currentObj.code
                })
                return finalObj
            },[])
            state.courseInfoForCheckout = coursesForCheckout
        },
        setItemsInCart(state, newCart) {
            state.checkoutCart = newCart
        },
        setcouponNotValidMessage(state, newMessage) {
            state.couponNotValidMessage = newMessage
        },
        setCouponHttpStatus(state, newStatus) {
            state.couponHttpStatus = newStatus
        }
    },
    actions:{
        conditionsAndPermissions(context,data){
            context.commit('setAcceptedConditions',data.conditions)
            context.commit('setAcceptedNewsletter',data.newsletter)
        },
        setheaderCartAmount(context, data) {
            context.commit("main/setCartIconAmount", data.itemsInCart, { root: true })
            injectNewHeaderCartData()
        },
        getCart(context) {
            const langElement = document.querySelector('HTML').getAttribute('commerce-lang')
            let url = process.env.GET_CART_ITEMS.replace("{language}", langElement)

            fetch(url)
                .then(res => {
                    if (res.ok) {
                        return res.json()
                    } else {
                        throw "Error - fecthing cart items"
                    }
                })
                .then(json => {
                    context.commit("setItemsInCart", json.cart)
                    context.commit('setCourseInfoForCheckout', json.cart.cartItems)
                    if (json.cartTotal) trackCartTotal(json.cartTotal)
                })
                .catch(err => {
                    console.error(err)
                })
        },
        getChangedQuantity(context, payload) {
            const langElement = document.querySelector('HTML').getAttribute('commerce-lang')
            let url = process.env.CHANGE_CART_ITEM_QUANTITY
                .replace("{code}", payload.code)
                .replace("{quantity}", payload.quantity)
                .replace("{language}", langElement)
            fetch(url)
                .then(res => {
                    if (res.ok) {
                        return res.json()
                    } else {
                        throw "Error - fecthing cart items"
                    }
                })
                .then(json => {
                    context.commit("setItemsInCart", json.cart)
                    context.dispatch("setheaderCartAmount", json)
                    trackCartTotal(json.cartTotal)
                })
                .catch(err => {
                    console.error(err)
                })
        },
        checkCouponCode(context, inputValue) {
            const langElement = document.querySelector('HTML').getAttribute('commerce-lang')
            const url = process.env.CHECK_COUPON_CODE
            const data = {
                CouponCode: inputValue,
                Language: langElement
            }

            fetch(url, {
                method: 'POST',
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            })
            .then(res => {
                if (res.ok) {
                    context.commit("setCouponHttpStatus", res.status)
                    return res.json()
                } else {
                    throw "Error - checking coupon code"
                }
            })
            .then(data => {
                const cartObj = data.cart || data.Cart
                if (data.couponCodeApplied) {
                    context.commit("setcouponNotValidMessage", null)
                    context.commit("setItemsInCart", data.cart)
                } else {
                    context.commit("setcouponNotValidMessage", data.couponCodeNotAppliedReason)
                    context.commit("setItemsInCart", data.cart)
                }
                if (data.cartTotal) trackCartTotal(data.cartTotal)
            })
            .catch(err => {
                console.error(err);
            });
        }    
    }
}